import { USER_ID_COOKIE, getCookie } from '@olxeu-a2b/core/src/utils/cookie';
import { getConfig } from '../extras/getConfig';

const { language } = getConfig();
const environment = process.env.A2B_ENV === 'production' ? 'production' : 'testing';
const enableQAPanel = process.env.A2B_ENV === 'staging';

const getDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

export const laquesisObserver = (() => {
  const listeners = [];
  let laquesisReady = false;

  window.laquesisAssignCallback = () => {
    laquesisReady = true;
    listeners.forEach(listener => listener());

    const userId = getCookie(USER_ID_COOKIE);
    window.laquesisSetUserId(userId);
  };

  return {
    subscribe: listener => {
      if (laquesisReady) {
        listener();
      } else {
        listeners.push(listener);
      }
    },
  };
})();

export const getNinja = () => {
  const userId = getCookie(USER_ID_COOKIE);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    cleanup() {
      window.dataLayer.push({
        userId,
      });
    },
  });
  const ninjaTag = document.getElementById('ninja-script-tag');
  if (!ninjaTag) {
    window.configTracking = {
      siteUrl: `www.olx.${language}`,
      environment,
      region: 'cee',
      setup: {},
      platform: window.matchMedia('(min-width: 1025px)').matches ? 'd' : 'm',
      userId: Number.parseInt(userId, 10),
    };
    // eslint-disable-next-line no-console
    console.info('ninjaTag added', window.configTracking);
    const ninjaPath = 'ninja.data.olxcdn.com/ninja-cee.js';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'ninja-script-tag';
    script.async = true;
    script.src = (document.location.protocol === 'https:' ? 'https://' : 'http://') + ninjaPath;
    (
      document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]
    ).appendChild(script);
  }
};

export const setup = () => getNinja();

export const trackPage = (pageName, platformType, extras = {}) => {
  const userId = getCookie(USER_ID_COOKIE);
  getDataLayer().push({
    language,
    platform: platformType,
    trackPage: pageName,
    user_id: userId,
    ...extras,
  });
};

export const trackEvent = (name, type, data = null, platformType, extras = {}) => {
  const userId = getCookie(USER_ID_COOKIE);
  getDataLayer().push({
    trackEvent: [name, type, data],
    platform: platformType,
    user_id: userId,
    ...extras,
  });
};

export const trackLink = (linkName, linkCallBack, platformType, extras) =>
  getDataLayer().push({
    trackLinkEvent: [linkName],
    linkCallBack,
    platform: platformType,
    ...extras,
  });
